import { ElementType, useState, createContext, FC } from 'react';
import Modal from '@material-ui/core/Modal';
import useStyles from './styles';

export interface IModalComponent {
  component: ElementType;
  props?: Record<string, unknown>;
}

interface IModalContext {
  modalComponent: IModalComponent | null;
  setModalComponent: (component: IModalComponent | null) => void;
}

const ModalContext = createContext<IModalContext>({
  modalComponent: null,
  setModalComponent: () => {
    // Empty function
  },
});

const ModalProvider: FC = ({ children }) => {
  const css = useStyles();
  const [modalComponent, setModalComponent] = useState<IModalComponent | null>(null);
  const { component: Component, props } = modalComponent || {};

  const handleSetModalComponent = (component: IModalComponent | null): void => {
    setModalComponent(component);
  };

  return (
    <ModalContext.Provider value={{ modalComponent, setModalComponent: handleSetModalComponent }}>
      {children}
      <Modal open={Boolean(Component)}>
        <div className={css.modalWrapper}>{Component && <Component {...props} />}</div>
      </Modal>
    </ModalContext.Provider>
  );
};

export { ModalContext, ModalProvider };
